import React from 'react';
import AttendancePresent from '../Attendance/AttendancePresent';

/** Manager/team-lead attendance workspace, server-scoped to direct reports. */
const TeamAttendance = () => <AttendancePresent teamOnly />;

export default TeamAttendance;
